module.exports = __webpack_public_path__ + "assets/img/logo2.ded773e4.png";